// NavFooter.js
import { connect } from 'react-redux';

import NavFooter from '../component/NavFooter.jsx';
import withRouter from '../component/WithRouter.jsx';

const mapStateToProps = (state, { location }) => {
  return {
    pathname: location.pathname,
  };
};

export default withRouter(connect(mapStateToProps, null)(NavFooter));
